import ErrorComponent from "@/components/ui/error";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/registrant/licenses/$licenseId/transfer",
)({
  component: TransferLicenseScreen,
});

function TransferLicenseScreen() {
  return (
    <ErrorComponent
      title="Transfer unavailable"
      message="Registrants can no longer transfer licenses from this portal."
    />
  );
}
